import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import adminApiClient, { User } from "../../../../api/admin";

type CreateUserInput = Partial<User> & {
  password: string;
  role: string;
  // Also opens a CollabPay collaborator for the new user.
  createCollaborator?: boolean;
};

const useCreateUserMutation = (
  options: UseMutationOptions<User, Error, CreateUserInput, unknown> = {},
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["createUser"],
    mutationFn: async (user: CreateUserInput) => {
      return adminApiClient.createUser(user);
    },
    ...options,
    // After `...options` so a caller's `onSuccess` does not shadow the
    // invalidation — it runs from inside this one instead.
    onSuccess: (data: User, variables: CreateUserInput, context: unknown) => {
      queryClient.invalidateQueries({
        queryKey: ["users"],
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
};
export default useCreateUserMutation;
